import {IDomService} from './dom.service.interface';
import {EventListenerRegistration} from '../../../utils/event-listener-registration';


export class DomService implements IDomService {
  constructor() {
    this._eventListenerRegistration = new EventListenerRegistration(document);
  }

  private initialBodyPaddingRight: string | null = null;
  private bodyPaddingRightAltered = false;
  disableScrolling(): void {
    // before we add the class "no-scrolling" (that has overflow: hidden) on the body
    // we check if a scrollbar exists. If it exists, we compute the scrollbar thickness and we add it to body's padding-right
    // WE COULD HAVE USED CSS `scrollbar-gutter: stable;` on `html` but that has problems. The spacing auto-added by the browser is outside the DOM
    // and seems to be above everything. Above the overlay, so clicking in that area does not close it
    // and above the right drawer, so the scrollbar of the drawer is not visible on desktop (on Chrome, doesn't happen on Firefox)
    // and also creates positioning problems for right drawers (like user menu on rtl languages)

    // instead of comparing document.body.scrollHeight > window.innerHeight to see if we have scrollable content we compare the widths
    // to see if we have a scrollbar. And the difference is the scrollbar thickness.
    if (window.innerWidth > document.body.clientWidth) {
      let scrollbarThickness = window.innerWidth - document.body.clientWidth;
      let bodyComputedStyles: CSSStyleDeclaration = window.getComputedStyle(document.body);
      this.initialBodyPaddingRight = bodyComputedStyles.paddingRight;
      this.bodyPaddingRightAltered = true;

      // increase padding by the scrollbar thickness
      this.body.style.paddingRight = "calc(" + this.initialBodyPaddingRight + " + " + scrollbarThickness + "px)";
    }
    this.body.classList.add('no-scrolling');
  }

  enableScrolling(): void {
    this.body.classList.remove('no-scrolling');
    if (this.bodyPaddingRightAltered) {
      this.bodyPaddingRightAltered = false;
      this.body.style.paddingRight = this.initialBodyPaddingRight;
    }
  }

  querySelector(selector: string): Element | null {
    return document.querySelector(selector);
  }

  get body(): HTMLElement {
    return document.body;
  }

  get head(): HTMLElement {
    return document.head;
  }

  get html(): HTMLElement {
      return document.documentElement;
  }

  setDocumentTitle(title: string): void {
    if(title) {
      document.title = title;
    }
  }

  get locationPathName(): string {
    return document.location.pathname;
  }

  private readonly _eventListenerRegistration;
  get subscribeTo(): EventListenerRegistration {
    return this._eventListenerRegistration;
  }

  getElementsByClassName(className: string): HTMLCollectionOf<Element> {
    return document.getElementsByClassName(className);
  }

  getElementsByTagName(tagName: string): HTMLCollectionOf<Element> {
    return document.getElementsByTagName(tagName);
  }

  getElementById(id: string): HTMLElement | null {
    return document.getElementById(id);
  }

  createElement(tagName: string): HTMLElement {
    return document.createElement(tagName);
  }
}
